import { Icon, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import InputSimple from '../../../components/textInputs/InputSimple/InputSimple';

export const RootStyled = styled('div')({
  width: '100%',
  height: '100%',
  background: '#000E1C',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '5rem',
});

export const ContainerInputStyled = styled('div')(({ theme }) => ({
  background: '#212334',
  width: '29rem',
  height: '23rem',
  borderTopLeftRadius: '1.5rem',
  borderBottomRightRadius: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  padding: '56px 32px',
  '& h2': {
    marginBottom: 32,
    color: theme.palette.global.white,
  },
  '& button': {
    width: '100%',
  },
}));

export const InputStyled = styled(InputSimple)(({ theme }) => ({
  marginBottom: '32px',
  padding: '0',
  '& span': {
    margin: '0',
    position: 'relative',
    width: '56px',
  },
  color: theme.palette.global.white,
  border: `1px solid ${theme.palette.global.white}`,
}));

export const IconStyled = styled(Icon)(({ theme }) => ({
  alignItems: 'center',
  color: theme.palette.global.white,
  cursor: 'pointer',
  display: 'flex',
  height: '56px',
  justifyContent: 'center',
  marginLeft: '10px',
  transition: '0.3s',
  width: '10%',
  '&:hover': {
    color: theme.palette.global.lightgray,
  },
}));

export const ButtonTextStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.global.white,
  fontWeight: theme.typography.h4.fontWeight,
  textAlign: 'center',
  height: 48,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
